class SidebarMenu extends HTMLElement {
    constructor() {
        super();
        this._boundEvents = {};
    }

    connectedCallback() {
        this.openButton = document.querySelector('.sidebar_open_button');
        this.closeButton = this.querySelector('.sidebar-close');
        this.backdrop = this.nextElementSibling;
        this.triggers = [...this.querySelectorAll('.sidebar_trigger')];
        this.layers = [...this.querySelectorAll('.sidebar_second_level')];

        if (!this.openButton || !this.closeButton) {
            console.warn('SidebarMenu: Missing required elements');
            return;
        }

        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');

        this._bindEvent(this.openButton, 'click', this.toggleSidebar.bind(this));
        this._bindEvent(this.closeButton, 'click', this.closeSidebar.bind(this));
        this._bindEvent(this.backdrop, 'click', this.closeSidebar.bind(this));
        this._bindEvent(document, 'keydown', this._handleKeydown.bind(this));
        this.triggers.forEach(button => {
            button.addEventListener('click', () => {
                this.openLayer(button);
            });
            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    button.click();
                }
            });
        });


        this._initLayers();
    }

    disconnectedCallback() {
        Object.values(this._boundEvents).forEach(({ target, type, handler }) => {
            target.removeEventListener(type, handler);
        });
    }

    openLayer(button) {
        console.log('Opening layer');
        const layerName = button.getAttribute('data-trigger');
        const layer = this.querySelector(`.sidebar_second_level[data-layer="${layerName}"]`);
        if (layer) {
            this.classList.add('layer-open');
            layer.classList.add('layer-open');
            setTimeout(() => trapFocus(layer, layer.querySelector('.second-layer-title')), 110);
        }
    }

    // --- Sidebar Control ---

    toggleSidebar() {
        const isOpen = this.classList.toggle('open');
        this._updateSidebarState(isOpen);
    }

    closeSidebar() {
        if (!this.classList.contains('open')) return;
        this.classList.remove('open');
        this._updateSidebarState(false);
    }

    _updateSidebarState(isOpen) {
        document.body.classList.toggle('overflow-hidden', isOpen);
        this.setAttribute('aria-hidden', (!isOpen).toString());
        this.toggleAttribute('inert', !isOpen);
        this.openButton.setAttribute('aria-expanded', isOpen.toString());

        if (isOpen) {
            setTimeout(() => trapFocus(this, this.closeButton), 110);
        } else {
            setTimeout(() => this._closeAllLayers(), 200);           
        }
    }

    _handleKeydown(e) {
        if (e.key === 'Escape') {
            this.closeSidebar();
        }
    }

    // --- Layers ---

    _initLayers() {
        this.layers.forEach(layer => {
            const closeBtn = layer.querySelector('.second-layer-title');
            const isOpen = layer.classList.contains('layer-open');

            closeBtn.addEventListener('click', () => {
                console.log('Closing layer');
                layer.classList.remove('layer-open');
            });
            closeBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    closeBtn.click();
                }
            });
        });
    }

    _closeAllLayers() {
        this.layers.forEach(layer => {
            if (layer.classList.contains('layer-open')) {
                layer.classList.remove('layer-open');
            }
        });
    }

    // --- Utility ---

    _bindEvent(target, type, handler) {
        target.addEventListener(type, handler);
        this._boundEvents[`${type}_${target.className || target.tagName}`] = { target, type, handler };
    }
}
customElements.define('sidebar-menu', SidebarMenu);
